const riot = require('riot');

riot.tag2('modal-confirm', '<div class="w-full pb12 bg-white modal border border-gray_light_10" ref="modal"> <div class="py20 ts-h3 text-center bg-gray_light_20">{opts.title || \'確認\'}</div> <div class="px20"> <div class="py40" if="{opts.text || opts.message}"> <div class="ts-text word-break-all white-space-pre-wrap" if="{opts.text || opts.message}">{opts.text || opts.message}</div> <div class="mt20" if="{opts.check_form}"> <div class="ts-caption text-gray_dark_20 mb4">{opts.check_form.key}</div> <input class="w-full input" ref="input" oninput="{onInput}"> </div> </div> <div class="f fr pt12 border-top border-gray_light_10"> <button class="button normal mr8" onclick="{cancel}">{opts.negative || \'キャンセル\'}</button> <button class="button {(!opts.check_form || isAgree) ? &quot;error&quot; : &quot;disabled&quot;}" onclick="{agree}">{opts.positive || \'OK\'}</button> </div> </div> </div>', 'modal-confirm .modal,[data-is="modal-confirm"] .modal{max-width:506px;max-height:80vh}', 'class="f fh s-full px16 bg-modal_overlay" spat-animation="fade"', function(opts) {
    this.isAgree = false;

    this.cancel = () => {
      this.value = false;
      this.close();
    };

    this.agree = () => {
      if (this.opts.check_form) {
        if (this.isAgree) {
          this.value = true;
          this.close();
          return;
        }
        else {
          spat.modal.alert('予期せぬエラーが発生しました');
          this.close();
          return;
        }
      }
      this.value = true;
      this.close();
    };

    this.onInput = () => {
      var result = this.refs.input.value === this.opts.check_form.value;
      if (result) {
        this.isAgree = true;
        this.update();
        return;
      }
      this.isAgree = false;
      this.update();
    };
});